<template>
<div class="ti">
  <div>
    <el-button size="mini" type="primary text2"  @click="modals" v-if="ERP.isPermission(7002001)">添加架构</el-button>
    <el-select size="mini" v-model="value" filterable placeholder="请选择组织" class="kuan" v-if="ERP.isPermission(7002004)">
      <el-option
        key=""
        label="全部"
        value="">
      </el-option>
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.company_name"
        :value="item.id">
      </el-option>
    </el-select>
    <!-- <el-select v-model="value1" filterable placeholder="请选择归属" class="kuan">
      <el-option
        key="0"
        label="全部"
        value="0">
      </el-option>
      <el-option
        v-for="item in options1"
        :key="item.id"
        :label="item.jname"
        :value="item.id">
      </el-option> -->
    <!-- </el-select> -->
    <el-input size="mini" class="search" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <div class="text6">架构新建绑定导入房产，生成订单后，不可删除架构，删除架构将可能导致订单不显示，只可修改，删除需联系运维人员</div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">架构名称</th>
            <th class="text-left">归属</th>
            <th class="text-left">组织信息</th>
            <th class="text-left">架构备注</th>
            <!-- <th class="text-left">创建人</th> -->
            <th class="text-left">日期</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.jname}}</td>
            <td >{{item.jnames}}</td>
            <td >{{item.company_name}}</td>
            <td ><div v-if="item.jremarks">{{item.jremarks}}</div><div v-else>--</div></td>
            <!-- <td >{{item.adname}}</td> -->
            <td >{{item.jdate}}</td>
            <td class="cdj_td">
              <div style="color: #1867c0;cursor: pointer;" @click="xiugai( item.id )" v-if="ERP.isPermission(7002002)">修改</div>
              <div  style="color: red;margin-left: 5px;cursor: pointer;" @click="del( item.id )" v-if="ERP.isPermission(7002003)">删除</div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="800"
        title="编辑"
        @on-ok="ok">
        <div>
          <el-form  label-width="80px" :model="dades">
            <el-form-item label="架构名称">
              <el-input v-model="dades.jname"></el-input>
            </el-form-item>
            <el-form-item label="所属组织">
              <el-select v-model="dades.company_id" filterable placeholder="请选择" v-if="cs == 2" disabled @change="changesa(dades.company_id)">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="dades.company_id" filterable placeholder="请选择" v-else @change="changesa(dades.company_id)">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="上级架构">
              <el-select v-model="opdadeval[0].valid" filterable placeholder="请选择" @change="changes(opdadeval[0].valid,0)">
                <el-option
                  v-for="item in opdade[0]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>

              <el-select v-model="opdadeval[1].valid" placeholder="请选择" v-if="opdade[1][0]['id']" @change="changes(opdadeval[1].valid,1)">
                <el-option
                  v-for="item in opdade[1]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[2].valid"  placeholder="请选择" v-if="opdade[2][0]['id']" @change="changes(opdadeval[2].valid,2)">
                <el-option
                  v-for="item in opdade[2]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[3].valid" style="margin-top: 3.6px;" placeholder="请选择" v-if="opdade[3][0]['id']" @change="changes(opdadeval[3].valid,3)">
                <el-option
                  v-for="item in opdade[3]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[4].valid"  placeholder="请选择" v-if="opdade[4][0]['id']" @change="changes(opdadeval[4].valid,4)">
                <el-option
                  v-for="item in opdade[4]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="opdadeval[5].valid" placeholder="请选择" v-if="opdade[5][0]['id']" @change="changes(opdadeval[5].valid,5)">
                <el-option
                  v-for="item in opdade[5]"
                  :key="item.id"
                  :label="item.jname"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="架构备注">
              <el-input v-model="dades.jremarks"></el-input>
            </el-form-item>
            <el-form-item label="架构权限" class="cdj_tree">
                <div class="text item">
                    <el-tree
                    :data="data"
                    show-checkbox
                    ref="tree"
                    node-key="id"
                    includeHalfChecked="false"
                    :default-expanded-keys="defaultcheckedkeyssa"
                    :default-checked-keys="defaultcheckedkeys">
                    </el-tree>
                </div>
            </el-form-item>
          </el-form>
        </div>
    </Modal>
</div>

</template>

<script>
import tree from "../../../assets/js/tree";
export default {
  name: 'JindexAdd',
  data () {
    return {
      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      data:[],
      opdadeval:[
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        },
        {
          valid:'',
        }
      ],
      opdade:[
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }],
        [{
          id:0,
          jname:'0',
        }]
      ],
      dades: {
        id:'',
        distinguish:'1',
        login_name:'',
        jname: '',
        company_id: '',
        company_id1:'',
        jremarks:'',
      },
       options: [
        {
          value: '',
          label: ''
        },],
        options1: [
        {
          value: '',
          label: ''
        },],
      options2:[],
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    var that=this;
    setTimeout(function () {
      that.data = JSON.parse(JSON.stringify(__MENU_LIST__));//tree
    },2000)
    ERP.showLoading()
    this.$Loading.start();
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    this.$myhttp.get('admin/getcompanygshu?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value1 = 0;
        this.$myhttp.get('admin/Jindex?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=1",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
          ERP.hideLoading()
        });
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
        this.options1 = backdata.data[1];
    });
  },
  computed:{
    __MENU_LIST__(){
      return ERP.getStore().__MENU_LIST__
    },
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  watch:{
    __MENU_LIST__(n){
      this.data = JSON.parse(JSON.stringify(n));//tree
    }
  },
  //事件
  methods: {
    //根据组织查归属
    changesa(e){
      this.$Loading.start();
      // console.log(e);
      this.$myhttp.get('admin/getJlistOps?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        this.opdade[0]=backdata.data[0];
        var bc = backdata.data[0];
        this.$forceUpdate();
        this.$myhttp.get('admin/sxjm',{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.opdade[0] = bc;
            this.opdadeval[0].valid="";
          });
        this.$Loading.finish();
      });
    },
    //监听选择归属改变
    changes(e,op){
      // console.log(e);//id
      // console.log(op);//属于哪一个数组
      this.$Loading.start();
      var ops = op+1;
      // console.log(ops);
      this.$myhttp.get('admin/getJlistOp?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        if(backdata.data[1] == 200){
          this.opdadeval[ops]['valid'] = '';
          if(ops == 1){
            this.opdade[1] = [{id:'',jname:'',}];
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 2){
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 3){
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 4){
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 5){
            this.opdade[5] = [{id:'',jname:'',}];
          }
          this.opdade[ops] = backdata.data[0];
        }else{
          this.opdadeval[ops]['valid'] = '';
          if(ops == 1){
            this.opdade[1] = [{id:'',jname:'',}];
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 2){
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 3){
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 4){
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
          }
          if(ops == 5){
            this.opdade[5] = [{id:'',jname:'',}];
          }
       }
       this.$Loading.finish();
      //  console.log(this.opdadeval);
       this.$forceUpdate();
      });
    },
    //保存权限
    ok(){
      if(this.dades.jname == ""){
        this.$Message.error('架构名称不能为空!');
        return false;
      }
      if(this.dades.company_id == ""){
        this.$Message.error('所属不能为空!');
        return false;
      }
      if(this.opdade[0].length !=0){
        if(this.opdadeval[0].valid == ''){
          this.$Message.error('上级架构不能为空!');
          return false;
        }
      }
      var id = this.$refs.tree.getCheckedKeys();//获得全选状态id
      var ids = this.$refs.tree.getHalfCheckedKeys();//获得半选状态的id
      var listid = id.concat(ids);//数组组合
      listid.sort();//排序
      var login = window.localStorage.getItem('login');
      this.dades.login_name = login;
      var date = [listid,this.dades,id,this.opdadeval,this.opdade];
      this.$Loading.start();
      this.$myhttp.post('admin/Jindexslistadd',date,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data['code'] == 202){
            this.$Message.error('自己不能是自己的上级!');
            this.$Loading.finish();
            return false;
          }
          if(backdata.data[0] == 1){
            var t = Date.parse(new Date()) / 1000;//时间戳
            this.$myhttp.get('admin/Jindex?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=1",{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
            });
            this.$Message.success(backdata.data[1]);

            // this.dades = {id:'',jname: '',company_id: '',jremarks:'',distinguish:'1'};
            this.opdadeval[0].valid="";
            this.dades= {
              id:'',
              distinguish:'1',
              login_name:'',
              jname: '',
              company_id: '',
              company_id1:'',
              jremarks:'',
            };
            this.$Loading.finish();
            this.$refs.tree.setCheckedKeys([]);
          }else{
            this.$Loading.finish();
            this.$Message.error('编辑失败!');
          }
      });
    },
    //弹窗添加
    modals(){
      this.$Loading.start();
      this.anxiu = "保存";
      if(this.dades.id){
        this.dades={id:'',login_name:'',jname: '',company_id: '',company_id1:'',jremarks:'',distinguish:'1'};
        this.opdade[1] = [{id:'',jname:'',}];
        this.opdade[2] = [{id:'',jname:'',}];
        this.opdade[3] = [{id:'',jname:'',}];
        this.opdade[4] = [{id:'',jname:'',}];
        this.opdade[5] = [{id:'',jname:'',}];
        this.opdadeval[0]['valid'] = '';
        this.$refs.tree.setCheckedKeys([]);
      }
       this.$myhttp.get('admin/getcompany',{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.options = backdata.data[0];
            this.options1 = backdata.data[1];
       });
      //加载公司权限列表
      var login = window.localStorage.getItem('login');
      this.$myhttp.get('admin/getJlist?login='+login,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[1] == 2){
              this.data =  backdata.data[0];
          }
          this.cs = backdata.data[1];
          this.dades.company_id=backdata.data[3];
          this.opdade[0] = backdata.data[4];
      });
      this.$Loading.finish();
      this.modal1 = true;
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/Jindex?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=1",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/Jindex?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=1",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
      });
    },
    //修改查询
    xiugai(e){
      this.$Loading.start();
      this.anxiu="修改";
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$refs.tree.setCheckedKeys([]);
      this.$myhttp.get('admin/getJlistupdate?id='+e+'&t='+t,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.defaultcheckedkeys = backdata.data[0];
          this.defaultcheckedkeyssa = backdata.data[0];
          this.dades = backdata.data[1][0];
          var das = backdata.data[1][0];
          this.cs = backdata.data[2];
          if(backdata.data[3].length == 0){
            var login = window.localStorage.getItem('login');
            this.$myhttp.get('admin/getJlist?login='+login,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                // this.cs = backdata.data[1];
                this.opdade[0] = backdata.data[4];
                this.opdade[1] = [{id:'',jname:'',}];
                this.opdade[2] = [{id:'',jname:'',}];
                this.opdade[3] = [{id:'',jname:'',}];
                this.opdade[4] = [{id:'',jname:'',}];
                this.opdade[5] = [{id:'',jname:'',}];
                this.$forceUpdate();
            });
          }else{
            this.opdadeval[0].valid = backdata.data[3];
            this.opdade[0] = backdata.data[4];
            this.opdade[1] = [{id:'',jname:'',}];
            this.opdade[2] = [{id:'',jname:'',}];
            this.opdade[3] = [{id:'',jname:'',}];
            this.opdade[4] = [{id:'',jname:'',}];
            this.opdade[5] = [{id:'',jname:'',}];
            // this.opdadeval = backdata.data[3];
            // this.opdade = backdata.data[4];
          }
          //加载公司权限列表
          var login = window.localStorage.getItem('login');
          this.$myhttp.get('admin/getJlist?login='+login,{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data[1] == 2){
                  this.data =  backdata.data[0];
              }
              this.cs = backdata.data[1];
              var op = this.opdade[0];
              if(op.length == 0){
                this.opdade[0] = [{id:das.id,jname:das.jname}];
                this.opdadeval[0]['valid'] = das.id;
              }
          });
          this.$Loading.finish();
          this.modal1 = true;
      });

      //加载公司权限列表
      var login = window.localStorage.getItem('login');
      this.$myhttp.get('admin/getJlist?login='+login,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.cs = backdata.data[1];
          // this.opdade[0] = backdata.data[4];
      });
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该项,删除将导致不可修复，删除先联系维护人员确定，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$Loading.start();
          this.$myhttp.post('admin/Jindexsdel',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              // console.log(backdata.data)
              if(backdata.data['code'] == 60006){
                 this.$Loading.finish();
                 this.$Message.error(backdata.data['date']);
                 return false;
              }
              if(backdata.data == 1){
                this.dela = true;
                var t = Date.parse(new Date()) / 1000;//时间戳
                this.$myhttp.get('admin/Jindex?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=1",{
                  'Content-Type': 'application/json'
                  }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.$Loading.finish();
                    this.$Message.success('删除成功!');
                  });
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text6{
  color: brown;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.dist{
  display: flex;
}
.cdj_tree{
    height:350px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Jurisdiction/JindexAdd.vue